import React, { useEffect, useState,useContext } from "react";
import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import axios from "axios";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import { useHistory } from "react-router-dom";
import "./StripePayment.css";

export default function CheckoutFormStripe() {
  const stripe = useStripe();
  const elements = useElements();

  const [showPayment, setShowPayment] = useState(true);
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { domin } = useContext(serverInfo);
  const history = useHistory();

  useEffect(() => {


    if(localStorage.getItem("amount")==undefined){
      history.push("/");
      return;
    }

    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      setShowPayment(false);

      localStorage.setItem("amount",undefined);
      localStorage.setItem("event_id",undefined);
      localStorage.setItem("event_type",undefined);


      switch (paymentIntent.status) {
        case "succeeded":
          axios.get("/sanctum/csrf-cookie").then((response) => {
            axios.post(`/api/user/payment-confirm`, {
              clientSecret: clientSecret,
            }).then((res) => {
              history.push(localStorage.getItem("redirectTo"));
              console.log(res)
            });
          });
          swal("Success", "Payment succeeded!", "success");
          break;
        case "processing":
          swal("Warning", "Your payment is processing.", "warning");
          break;
        case "requires_payment_method":
          swal("Error", "Your payment was not successful, please try again.", "error");
          break;
        default:
          swal("Error", "Something went wrong.", "error");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: domin+"/stripe-payment",
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    <>
      {showPayment && (
        <form id="payment-form" onSubmit={handleSubmit}>
          <PaymentElement id="payment-element" options={paymentElementOptions} />
          <button disabled={isLoading || !stripe || !elements} id="submit">
            ({"$" + localStorage.getItem("amount")}){"  "}
            <span id="button-text">
              {isLoading ? (
                <div className="stripe_spinner" id="stripe_spinner"></div>
              ) : (
                  "Pay Now"
                )}
            </span>
          </button>
          {/* Show any error or success messages */}
          {message && <div id="payment-message">{message}</div>}
        </form>
      )}
    </>
  );
}